import { Hero } from "@/components/home/Hero";
import { TrustStrip } from "@/components/home/TrustStrip";
import { Services } from "@/components/home/Services";
import { HowItWorks } from "@/components/home/HowItWorks";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { Results } from "@/components/home/Results";
import { Testimonials } from "@/components/home/Testimonials";
import { CTA } from "@/components/home/CTA";
import { PageExtraSections } from "@/components/sections/PageExtraSections";
import { REVIEW_FORM_ANCHOR } from "@/components/sections/ReviewFormSection";
import { useAboutContent } from "@/hooks/useAboutContent";
import { usePageExtraSections } from "@/hooks/usePageExtraSections";
import { isAwaitingFirstResult, useTenantOrgId } from "@/hooks/useTenantOrgId";
import { useDemoShowcase } from "@/hooks/useDemoShowcase";

/** The homepage sections, shared by the live homepage and the admin theme preview frame. */
export function HomeSections() {
  const orgId = useTenantOrgId();
  const demo = useDemoShowcase();
  // The homepage results gallery reuses the tenant's About-page results images.
  const aboutPendingQuery = useAboutContent(orgId);
  const { data: aboutContent } = aboutPendingQuery;
  const aboutPending = isAwaitingFirstResult(aboutPendingQuery);
  const results = aboutContent?.results;
  // Optional page-builder blocks (e.g. "Leave a review") the owner added to the homepage.
  const { data: extraSections } = usePageExtraSections(orgId, "home");
  const hasReviewForm = extraSections?.some((section) => section.section_type === "review_form") ?? false;

  return (
    <div className="motion-page">
      <Hero />
      <TrustStrip />
      <Services />
      <HowItWorks />
      <WhyChooseUs />
      <Results
        eyebrow="Results"
        title={demo?.homeResults.title ?? "The difference a proper clean makes"}
        description={demo?.homeResults.description ?? "Real rooms, properly finished. This is the standard we leave behind on every visit."}
        images={results?.images}
        loading={aboutPending}
      />
      <Testimonials reviewFormHref={hasReviewForm ? `#${REVIEW_FORM_ANCHOR}` : undefined} />
      <PageExtraSections sections={extraSections} />
      <CTA />
    </div>
  );
}
